function FixtureMedia() {
  return <div className="page">FixtureMedia</div>;
}

export default FixtureMedia;
